import EventGL from './gl/eventgl';
import Canvas from './kv_fall/canvas';
import Intro from './intro';
import ScrollFunc from './scrollfunc';
export default class Main {
    constructor() {
        //instances
        this.gl = new EventGL();
        this.ScrollFunc = new ScrollFunc();
        this.canvas = new Canvas();
        this.intro = new Intro();

        this.init();
    }

    init() {
        this.eventBind();
    }

    eventBind() {
        const that = this;

        window.addEventListener('load', (e) => {
            this.intro.introAnm();
            this.set100vh();
        });

        window.addEventListener('scroll', (e) => {
            this.onScroll(document.documentElement || document.body);
        });

        // リサイズ時
        let timer = 0;
        window.onresize = function () {
            if (timer > 0) {
                clearTimeout(timer);
            }

            timer = setTimeout(function () {
                that.set100vh();
            }, 200);
        };
    }

    set100vh() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    onScroll($container) {
        const body = document.body;
        const scrollTop = $container.scrollTop;

        const scrollLimit = window.innerWidth < 768 ? 10 : 300;

        if (scrollTop >= scrollLimit) {
            body.classList.add('-onscroll');
        } else {
            body.classList.remove('-onscroll');
        }
    }
}
